import MyLocationIcon from '@mui/icons-material/MyLocation';
import CircularProgress from '@mui/material/CircularProgress';
import clsx from 'clsx';
import { Map } from 'ol';
import { Control } from 'ol/control';
import { CLASS_CONTROL, CLASS_UNSELECTABLE } from 'ol/css';
import React from 'react';
import { createRoot } from 'react-dom/client';

import useCurrentLocation from '../hooks/useCurrentLocation';

interface CurrentLocationButtonProps {
  getMap: () => Map | null;
  tooltip: string;
}

export const CurrentLocationButton = ({ getMap, tooltip }: CurrentLocationButtonProps) => {
  const map = getMap();
  const [loading, handleClick] = useCurrentLocation(map);

  const className = clsx('current-location', CLASS_UNSELECTABLE, CLASS_CONTROL);

  return (
    <div className={className}>
      <button title={tooltip} type="button" onClick={handleClick}>
        {loading ? (
          <CircularProgress style={{ verticalAlign: 'middle' }} />
        ) : (
          <MyLocationIcon fontSize="small" style={{ verticalAlign: 'middle' }} />
        )}
      </button>
    </div>
  );
};

class CurrentLocationControl extends Control {
  constructor(tooltip: string) {
    const element = document.createElement('div');
    super({ element });

    const root = createRoot(element);
    root.render(<CurrentLocationButton getMap={this.getMap.bind(this)} tooltip={tooltip} />);
  }
}

export default CurrentLocationControl;
